module.exports = __webpack_public_path__ + "static/mck-fd4151f8e21773bf688aea20d5ffa9e8.png";